export default (url) => url.replace(/https?:\/\/[^/]+|\?.+$/g, '');
